import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";
import { useNavigate } from "react-router-dom";

export default function HowItWorks() {
  const navigate = useNavigate();
  const steps = [
    {
      title: "1. Create Your Account",
      description:
        "Register using your mobile number or email address. Verify your account through OTP to get started on your matrimonial journey.",
    },
    {
      title: "2. Verify Your Profile",
      description:
        "Complete Aadhaar verification to increase your profile's credibility. Verified profiles are more trusted by other members.",
    },
    {
      title: "3. Complete Your Profile",
      description:
        "Add your personal information, education, profession, family details, partner preferences and upload recent photographs. A complete profile attracts more genuine matches.",
    },

    {
      title: "4. Search for Matches",
      description:
        "Use our advanced search filters to find compatible matches based on age, religion, caste, education, profession, location and other preferences.",
    },
    {
      title: "5. Receive Personalized Match Suggestions",
      description:
        "Our intelligent matching system recommends profiles that closely match your preferences and compatibility criteria.",
    },
    {
      title: "6. Express Interest",
      description:
        "Send an interest request to members you like. They can accept or decline your request based on their preferences.",
    },
    {
      title: "7. Start Communicating",
      description:
        "Once your interest is accepted, eligible members can communicate through the platform according to their membership plan.",
    },
    {
      title: "8. Upgrade to Premium",
      description:
        "Unlock premium features like unlimited profile views, contact details access, priority visibility and advanced search filters.",
    },
    {
      title: "9. Find Your Life Partner",
      description:
        "Take your time to know each other, involve your families and make informed decisions before taking the next step toward marriage.",
    },
  ];

  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>
          How It Works
        </h1>
        <p className="text-muted mt-3">
          Finding your perfect life partner is simple. Follow these easy steps.
        </p>
      </div>

      {/* HOW IT WORKS */}
      <Container style={{ padding: "70px 0" }}>
        <Row className="justify-content-center">
          <Col lg={10}>
            {steps.map((step, index) => (
              <Card
                key={index}
                className="border-0 shadow-sm mb-4"
                style={{ borderLeft: "5px solid #7b1e3b" }}
              >
                <Card.Body>
                  <h4
                    style={{
                      color: "#7b1e3b",
                      fontWeight: 600,
                    }}
                  >
                    {step.title}
                  </h4>

                  <p
                    style={{
                      color: "#555",
                      marginBottom: 0,
                      lineHeight: "1.8",
                    }}
                  >
                    {step.description}
                  </p>
                </Card.Body>
              </Card>
            ))}
          </Col>
        </Row>

        <Row className="justify-content-center mt-5">
          <Col lg={10}>
            <Card
              className="border-0 shadow"
              style={{
                background: "#fff8fa",
              }}
            >
              <Card.Body className="text-center p-5">
                <h3 style={{ color: "#7b1e3b" }}>
                  Ready to Find Your Perfect Match?
                </h3>

                <p className="text-muted mt-3 mb-0">
                  Join thousands of verified members who are searching for a
                  meaningful and lifelong relationship. Complete your profile,
                  explore compatible matches and begin your journey toward a
                  happy married life today.
                </p>
                <div className="center">
                  <Button
                    className="about-btn" style={{ width: "200px" }}
                    onClick={() => navigate("/register")}
                  >
                    Create Your Profile
                  </Button>
                </div>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}